import { sendImportRemoteRuntimeEvent } from './events';
import { loadRemoteModule } from '../helpers/loadRemoteModule';
import { promiseWithRetries } from '../helpers/promiseWithRetries';
import { getExoSkeletonRuntime } from '../internal';
const MAX_RETRIES = 3;
const IMPORT_REMOTE_RETRY_TYPES = {
  GET_REMOTE: 'IMPORT_REMOTE_RETRY__GET_REMOTE',
  RESOLVE_REMOTE: 'IMPORT_REMOTE_RETRY__RESOLVE_REMOTE'
};
export async function importRemote(_ref) {
  var _exoRuntime$remotes;
  let {
    scope,
    module,
    onRetry = () => {}
  } = _ref;
  const performanceMark = window.performance.mark('importRemoteStart');
  const exoRuntime = getExoSkeletonRuntime();
  const scopeRuntimeInfo = (_exoRuntime$remotes = exoRuntime.remotes) === null || _exoRuntime$remotes === void 0 ? void 0 : _exoRuntime$remotes[scope];
  if (!scopeRuntimeInfo) {
    throw new Error(`ExoSkeletonAPI Error: No remote found for scope "${scope}"`);
  }
  let remote;
  try {
    const scopeRuntimeInfoResponse = await promiseWithRetries(() => scopeRuntimeInfo.get(), {
      retries: MAX_RETRIES,
      onRetry(error, tryAttempt) {
        return onRetry({
          error,
          tryAttempt,
          retryName: IMPORT_REMOTE_RETRY_TYPES.GET_REMOTE
        });
      }
    });
    remote = scopeRuntimeInfoResponse;
  } catch (cause) {
    throw new Error(`ExoSkeletonAPI Error: Failed to get the remote for scope "${scope}"\n${cause}`, {
      cause
    });
  }
  const {
    url
  } = remote;
  try {
    let importTryAttempt = 0;
    const resolvedPromise = await promiseWithRetries(_ref2 => {
      let {
        attempt
      } = _ref2;
      return loadRemoteModule({
        bustRemoteEntryCache: attempt > 1,
        scope,
        url,
        module
      });
    }, {
      retries: MAX_RETRIES,
      onRetry(error, tryAttempt) {
        importTryAttempt = tryAttempt;
        return onRetry({
          error,
          tryAttempt,
          retryName: IMPORT_REMOTE_RETRY_TYPES.RESOLVE_REMOTE
        });
      }
    });
    void sendImportRemoteRuntimeEvent({
      scope,
      metadata: {
        url,
        retryAttempt: importTryAttempt,
        timeToImport: window.performance.now() - performanceMark.startTime
      }
    });
    return resolvedPromise;
  } catch (cause) {
    throw new Error(`ExoSkeletonAPI Error: Failed to resolve remote "${module}" from scope "${scope}"\n${cause}`, {
      cause
    });
  } finally {
    window.performance.clearMarks('importRemoteStart');
  }
}
//# sourceMappingURL=import.js.map